/**
 * Sessione lato client.
 *
 * Il server e l'unica fonte di verita sull'autenticazione: qui si interroga
 * `/api/io` a ogni caricamento e si tiene il risultato in memoria, senza
 * duplicare nulla in storage locale che potrebbe disallinearsi dal cookie.
 */

import { useCallback, useEffect, useState } from 'react';
import type { Assegnazione } from '@calcio/shared';
import { chiama } from '../api/client.js';

export interface Utente {
  accountId: string;
  nome: string;
  cognome: string;
  email: string;
  /** Nome della societa, null per il Super Admin senza societa. */
  societa: string | null;
  societaId: string;
  superAdmin: boolean;
  /** Per filtrare il menu: il server resta l'unico a decidere cosa si puo fare. */
  assegnazioni: Assegnazione[];
}

type Stato =
  { fase: 'caricamento' } | { fase: 'anonimo' } | { fase: 'autenticato'; utente: Utente };

export function useSessione() {
  const [stato, setStato] = useState<Stato>({ fase: 'caricamento' });

  const ricarica = useCallback(async () => {
    try {
      const utente = await chiama<Utente>('/io');
      setStato({ fase: 'autenticato', utente });
    } catch {
      setStato({ fase: 'anonimo' });
    }
  }, []);

  useEffect(() => {
    void ricarica();
  }, [ricarica]);

  const esci = useCallback(async () => {
    await chiama('/esci', { metodo: 'POST' });
    setStato({ fase: 'anonimo' });
  }, []);

  return { stato, ricarica, esci };
}
